// this code to see the bulk print orders from admin dashboard "button :  View Print Orders Request"
import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
  orderBy,
  query,
  where,
  doc,
  updateDoc,
  serverTimestamp,
  getDoc,
  deleteDoc,
} from "firebase/firestore";
import { Modal, Button, Table, Form } from "react-bootstrap";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const BulkOrderRequests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [statusUpdate, setStatusUpdate] = useState("");
  const [courierInfo, setCourierInfo] = useState({
    name: "",
    cod: "",
    date: "",
  });
  const [rejectedOrders, setRejectedOrders] = useState({});
  const [showReasonInput, setShowReasonInput] = useState({});
  const [tempReason, setTempReason] = useState({});
  const [acceptedOrders, setAcceptedOrders] = useState({});
  const [role, setRole] = useState("agent");
  const [accountId, setAccountId] = useState(null);
  // let accountId = "620374";

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const uid = user.uid;
        try {
          const userDocRef = doc(db, "users", uid);
          const userDocSnap = await getDoc(userDocRef);

          if (userDocSnap.exists()) {
            const userData = userDocSnap.data();
            setAccountId(userData.accountId);
            setRole(userData.role); // Optional: fetch role too
          } else {
            setLoading(false);
          }
        } catch (error) {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []); // Step 2: Fetch bulk orders using accountId

  useEffect(() => {
    const fetchRequests = async () => {
      if (!role) return;

      // Wait until accountId is available for agents
      if (role === "agent" && !accountId) return;

      setLoading(true);

      try {
        let q;

        if (role === "agent") {
          q = query(
            collection(db, "bulkOrders"),
            where("accountId", "==", accountId)
          );
        } else if (role === "user") {
          console.log("current logged role status ", role);
          q = query(
            collection(db, "bulkOrders"),
            where("accountId", "==", accountId)
          );
        } else {
          q = query(collection(db, "bulkOrders"));
        }

        const snapshot = await getDocs(q);
        // snapshot.forEach((doc) =>
        //   console.log("Doc ID:", doc.id, "Data:", doc.data())
        // );

        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setRequests(data);
      } catch (error) {
        console.error("Error fetching bulk orders:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRequests();
  }, [accountId, role]);

  //   //////////////////////////////
  //   useEffect(() => {
  //     const fetchRequests = async () => {
  //       if (!role) return;
  //       setLoading(true);

  //       try {
  //         let q;

  //         if (role === "agent" && accountId) {
  //           // console.log(
  //           //   "Querying bulkOrders for agent with accountId:",
  //           //   accountId,
  //           //   "and type:",
  //           //   typeof accountId
  //           // );

  //           q = query(
  //             collection(db, "bulkOrders"),
  //             where("accountId", "==", accountId)
  //           );
  //         } else if (role === "admin") {
  //           q = query(collection(db, "bulkOrders"));
  //         } else {
  //           console.warn("Unknown role or missing accountId for agent");
  //           setRequests([]);
  //           setLoading(false);
  //           return;
  //         }

  //         const snapshot = await getDocs(q);
  //         const data = snapshot.docs.map((doc) => ({
  //           id: doc.id,
  //           ...doc.data(),
  //         }));

  //         setRequests(data);
  //       } catch (error) {
  //         console.error("Error fetching bulk orders:", error);
  //       } finally {
  //         setLoading(false);
  //       }
  //     };

  //     fetchRequests();
  //   }, [accountId, role]);
  // // =============================
  // useEffect(() => {
  //   const fetchRequests = async () => {
  //     try {
  //       console.log("Fetching data for role:", role);
  //       console.log("Account ID:", accountId);

  //       let q;

  //       if (role === "agent" && accountId) {
  //         q = query(
  //           collection(db, "bulkOrders"),
  //           where("accountId", "==", accountId),
  //           orderBy("timestamp", "desc")
  //         );
  //       } else {
  //         q = query(collection(db, "bulkOrders"), orderBy("timestamp", "desc"));
  //       }

  //       const snapshot = await getDocs(q);
  //       const data = snapshot.docs.map((doc) => ({
  //         id: doc.id,
  //         ...doc.data(),
  //       }));

  //       console.log("Fetched data:", data);

  //       setRequests(data);
  //     } catch (error) {
  //       console.error("Error fetching bulk orders:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchRequests();
  // }, [role, accountId]);

  // useEffect(() => {
  //   const fetchRequests = async () => {
  //     try {
  //       let q;

  //       // const q = query(
  //       //   collection(db, "bulkOrders"),
  //       //   orderBy("timestamp", "desc")
  //       // );

  //       if (role === "agent" && accountId) {
  //         q = query(collection(db, "bulkOrders"), orderBy("timestamp", "desc"));
  //       } else {
  //         q = query(collection(db, "bulkOrders"), orderBy("timestamp", "desc"));
  //       }

  //       const snapshot = await getDocs(q);
  //       const data = snapshot.docs.map((doc) => ({
  //         id: doc.id,
  //         ...doc.data(),
  //       }));

  //       if (role === "agent" && accountId) {
  //         data = data.filter((item) => item.accountId === accountId);

  //         console.log("Agent role:", role);
  //         console.log("Agent accountId:", accountId);
  //         console.log("All fetched data:", data);
  //       }
  //       setRequests(data);
  //     } catch (error) {
  //       console.error("Error fetching bulk orders:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchRequests();
  // }, [role, accountId]);

  const handleDeleteRequest = async (id) => {
    if (window.confirm("Are you sure you want to delete this order request?")) {
      try {
        await deleteDoc(doc(db, "bulkOrders", id)); // Adjust collection name if needed
        setRequests((prev) => prev.filter((req) => req.id !== id));
      } catch (error) {
        console.error("Error deleting request:", error);
      }
    }
  };

  const getPendingDays = (timestamp) => {
    if (!timestamp?.toDate) return "N/A";
    const now = new Date();
    const created = timestamp.toDate();
    const diff = Math.floor((now - created) / (1000 * 60 * 60 * 24));
    return `${diff} days`;
  };

  const handleRowClick = (req) => {
    setSelectedRequest(req);
    setStatusUpdate(req.status);
    setCourierInfo({
      name: req.courierName || "",
      cod: req.courierCOD || "",
      date: req.courierDate || "",
    });
    setRejectedOrders(req.rejectedOrders || {});
    setShowReasonInput({});
    setTempReason({});
    setShowModal(true);
  };

  const handleDownloadExcel = (req) => {
    if (!req.orders || req.orders.length === 0) {
      alert("No order data to download.");
      return;
    }

    const worksheetData = req.orders.map((order, idx) => ({
      "S.No": idx + 1,
      "Ration Card Number": order.rationCardNumber,
      Name: order.name,
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

    const filename = `${req.accountId}_${req.orderId}.xlsx`;
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, filename);
  };

  const handleSave = async () => {
    try {
      const updates = {
        status: statusUpdate,
        updatedAt: serverTimestamp(),
        rejectedOrders,
      };
      if (statusUpdate === "completed") {
        updates.courierName = courierInfo.name;
        updates.courierCOD = courierInfo.cod;
        updates.courierDate = courierInfo.date;
      }

      const ref = doc(db, "bulkOrders", selectedRequest.id);
      await updateDoc(ref, updates);

      // Fetch fresh data for that order after save
      const updatedDoc = await getDoc(ref);
      const updatedData = { id: updatedDoc.id, ...updatedDoc.data() };

      // Update list
      const updatedRequests = requests.map((req) =>
        req.id === selectedRequest.id ? updatedData : req
      );

      setRequests(updatedRequests);
      alert("Status updated successfully");
      setShowModal(false);
    } catch (error) {
      console.error("Error updating order:", error);
    }
  };

  const handleRejectClick = (index) => {
    setShowReasonInput((prev) => ({ ...prev, [index]: true }));
  };

  const handleAcceptClick = (index) => {
    const updatedRejectedOrders = { ...rejectedOrders };
    delete updatedRejectedOrders[index];
    setRejectedOrders(updatedRejectedOrders);

    setAcceptedOrders((prev) => ({ ...prev, [index]: true }));
    setShowReasonInput((prev) => ({ ...prev, [index]: false }));
  };

  const handleTempReasonChange = (index, value) => {
    setTempReason((prev) => ({ ...prev, [index]: value }));
  };

  const confirmRejectReason = (index) => {
    if (tempReason[index]) {
      setRejectedOrders((prev) => ({ ...prev, [index]: tempReason[index] }));
      setShowReasonInput((prev) => ({ ...prev, [index]: false }));
    }
  };

  if (loading)
    return <div className="container mt-5">Loading bulk orders...</div>;

  return (
    <div className="container mt-4">
      {role === "admin" && (
        <>
          <h3>Bulk Order Requests</h3>
        </>
      )}
      {loading ? (
        <p>Loading...</p>
      ) : requests.length === 0 ? (
        <p>No orders found for this agent.</p>
      ) : (
        <Table striped bordered hover responsive>
          <thead className="bg bg-info">
            <tr>
              <th>Order ID</th>
              <th>Account ID</th>
              <th>Role</th>
              <th>Name</th>
              <th>#Entries</th>
              <th>Status</th>
              <th>Pending Days</th>
              {role === "admin" && (
                <>
                  <th>Download</th>
                  <th>Action</th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {requests.map((req) => (
              <tr
                key={req.id}
                onClick={() => handleRowClick(req)}
                style={{ cursor: "pointer" }}
              >
                <td>{req.orderId}</td>
                <td>{req.accountId}</td>
                <td>{req.sentBy}</td>
                <td>{req.username}</td>
                <td>{req.orders?.length || 0}</td>
                <td>{req.status}</td>
                <td>{getPendingDays(req.timestamp)}</td>

                {/* <td>
                {" "}
                <Button
                  variant="danger"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteRequest(req.id);
                  }}
                >
                  Delete{" "}
                </Button>{" "}
              </td> */}

                {role === "admin" && (
                  <>
                    <td>
                      <Button
                        variant="success"
                        size="sm"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDownloadExcel(req);
                        }}
                        className="me-2"
                      >
                        Download
                      </Button>
                    </td>
                    <td>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteRequest(req.id);
                        }}
                      >
                        Delete
                      </Button>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Order Details - {selectedRequest?.orderId}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedRequest && (
            <div>
              <p>
                <strong>Account ID:</strong> {selectedRequest.accountId}
              </p>
              <p>
                <strong>Agent Name:</strong> {selectedRequest.username}
              </p>
              <p>
                <strong>Status:</strong> {selectedRequest.status}
              </p>
              <p>
                <strong>Order Placed:</strong>{" "}
                {selectedRequest.timestamp?.toDate().toLocaleString() || "N/A"}
              </p>
              <p>
                <strong>Updated:</strong>{" "}
                {selectedRequest.updatedAt &&
                typeof selectedRequest.updatedAt.toDate === "function"
                  ? selectedRequest.updatedAt.toDate().toLocaleString()
                  : "N/A"}
              </p>
              <Table bordered size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Ration Card Number</th>
                    <th>Name</th>
                    {role === "admin" && (
                      <>
                        <th>Action</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {selectedRequest.orders?.map((order, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{order.rationCardNumber}</td>
                      <td>{order.name}</td>
                      <td>
                        {role === "admin" && (
                          <>
                            {rejectedOrders[idx] ? (
                              <>
                                <span className="text-danger">Rejected</span>
                                <br />
                                <small>
                                  <strong>Reason:</strong> {rejectedOrders[idx]}
                                </small>
                              </>
                            ) : acceptedOrders[idx] ? (
                              <span className="text-success">Accepted</span>
                            ) : (
                              <>
                                <Button
                                  size="sm"
                                  variant="success"
                                  className="me-2"
                                  onClick={() => handleAcceptClick(idx)}
                                >
                                  Accept
                                </Button>
                                <Button
                                  size="sm"
                                  variant="danger"
                                  onClick={() => handleRejectClick(idx)}
                                >
                                  Reject
                                </Button>
                              </>
                            )}

                            {showReasonInput[idx] && (
                              <div className="mt-2">
                                <Form.Control
                                  type="text"
                                  placeholder="Enter reason"
                                  value={tempReason[idx] || ""}
                                  onChange={(e) =>
                                    handleTempReasonChange(idx, e.target.value)
                                  }
                                />
                                <Button
                                  size="sm"
                                  className="mt-1"
                                  onClick={() => confirmRejectReason(idx)}
                                >
                                  Add Reason
                                </Button>
                              </div>
                            )}
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {selectedRequest.status !== "completed" ? (
                <Form.Group className="mt-3">
                  {role === "admin" && (
                    <>
                      <Form.Label>Update Status</Form.Label>
                      <Form.Select
                        value={statusUpdate}
                        onChange={(e) => setStatusUpdate(e.target.value)}
                      >
                        <option value="pending">Pending</option>
                        <option value="started">Started</option>
                        <option value="printing">Printing</option>
                        <option value="in courier">In Courier</option>
                        <option value="completed">Completed</option>
                      </Form.Select>
                    </>
                  )}
                </Form.Group>
              ) : (
                <div className="mt-3 d-flex flex-row gap-3 border border-2 justify-content-center align-items-center">
                  <p>
                    <strong>Courier Name:</strong>{" "}
                    {selectedRequest.courierName || "N/A"}
                  </p>
                  <p>
                    <strong>Courier COD:</strong>{" "}
                    {selectedRequest.courierCOD || "N/A"}
                  </p>
                  <p>
                    <strong>Courier Date:</strong>{" "}
                    {selectedRequest.courierDate || "N/A"}
                  </p>
                </div>
              )}
              {role === "admin" && (
                <>
                  {statusUpdate === "completed" &&
                    selectedRequest.status !== "completed" && (
                      <div className="mt-3">
                        <Form.Group className="mb-2">
                          <Form.Label>Courier Name</Form.Label>
                          <Form.Control
                            type="text"
                            value={courierInfo.name}
                            onChange={(e) =>
                              setCourierInfo({
                                ...courierInfo,
                                name: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                        <Form.Group className="mb-2">
                          <Form.Label>Courier COD</Form.Label>
                          <Form.Control
                            type="text"
                            value={courierInfo.cod}
                            onChange={(e) =>
                              setCourierInfo({
                                ...courierInfo,
                                cod: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                        <Form.Group className="mb-2">
                          <Form.Label>Courier Date</Form.Label>
                          <Form.Control
                            type="date"
                            value={courierInfo.date}
                            onChange={(e) =>
                              setCourierInfo({
                                ...courierInfo,
                                date: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </div>
                    )}
                </>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          {role === "admin" && (
            <>
              {selectedRequest?.status !== "completed" && (
                <Button variant="primary" onClick={handleSave}>
                  Save Changes
                </Button>
              )}
            </>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BulkOrderRequests;
